<template>
  <div class="app" v-if="!isLoading" :class="{
    'app--home': $route.fullPath === '/',
  }">
    <VMedia class="app__logo" v-if="$route.fullPath !== '/'">
      <img src="@/assets/logo.png" />
    </VMedia>

    <transition name="fade" mode="out-in" appear>
      <router-view :key="$route.fullPath" />
    </transition>

    <VMedia class="app__footer">
      <img src="@/assets/footer.png" />
    </VMedia>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RESET_LOADING, BEGIN_LOADING, END_LOADING } from '@/store';
import config from '@/config';
import VMedia from '@/components/VMedia.vue';

export default {
  name: 'App',

  components: {
    VMedia,
  },

  created() {
    const { languageCode } = config;

    this.$store.commit(RESET_LOADING);

    this.loadDictionary(languageCode);
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },

  methods: {
    async loadDictionary(languageCode) {
      const FAKE_DELAY = 0;

      this.$store.commit(BEGIN_LOADING);

      this.$i18n.setLocaleMessage(
        languageCode,
        (await this.$bricodes.getDictionary(languageCode)).data,
      );

      this.$i18n.locale = languageCode;

      setTimeout(() => {
        this.$store.commit(END_LOADING);
      }, FAKE_DELAY);
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';
@import '~animate.css/animate.min.css';
@import './styles/main.scss';

@font-face {
  font-family: 'Antonio';
  src: url('~@/assets/Antonio-Regular.woff2') format('woff2'),
    url('~@/assets/Antonio-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

body {
  background-image: url('~@/assets/body-background.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
}

.app {
  overflow: hidden;
  position: relative;

  max-width: $width;
  margin: 0 auto;

  font-family: Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  background-image: url('~@/assets/app-background.png');
  background-position: top center;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-color: #C45EE2;

  transition: background-image 0.25s;

  &--home {
    background-image: url('~@/assets/home-background.png');
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
  }

  &__bar {
    padding: 20px;

    font-weight: 900;
    text-transform: uppercase;
    color: #ffffff;

    background-color: #000000;
  }

  &__logo {
    width: 100%;
    max-width: 442px;
    margin: 50px auto;
  }

  &__artwork {
    width: 100%;
    max-width: 770px;
    margin: 20px auto 0;

    transition: max-width 0.5s ease-in-out;

    &--big {
      max-width: 940px;
    }
  }
}

.cta {
  padding: 50px;
  background-color: #000000;

  .text {
    text-transform: uppercase;
    color: #ffffff;
  }

  &__artwork {
    max-width: 770px;
    margin: 50px auto 0;
  }

  &__button {
    margin-top: -5% !important;
  }
}

.footer {
  padding: 40px;

  color: #000000;
  text-transform: uppercase;

  background-color: #ffffff;

  &__logos {
    margin-top: 40px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    flex: 1 1 25%;
    max-width: 25%;
    padding: 10px;

    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
